import React, { useState, useEffect } from 'react';
import { Row, Col, Card, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function EbEnrollment({ caseId, onError = () => { } }) {
    const fetchUrl = `${config.API_URL}/EBEnrollments/ByCaseId/${caseId}`;

    const [enrollment, setEnrollment] = useState({});
    const [originalEnrollment, setOriginalData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchGeneralInfo();
        fetchOriginalEnrollment();
    }, [caseId]);

    const fetchGeneralInfo = async () => {
        try {
            const response = await axios.get(fetchUrl);
            setEnrollment(response.data || null);
        } catch (error) {
            setError('Error fetching plans.');
        } finally {
            setLoading(false);
        }
    };

    const fetchOriginalEnrollment = async () => {
        try {
            const response = await axios.get(`${config.API_URL}/EBEnrollments/OriginalData/ByCaseId/${caseId}`);
            const originalData = response.data || [];
            setOriginalData(originalData);
        } catch (error) {
            if (error.response?.status !== 404) {
                setError('Error fetching original case files.');
            }
            onError(error);
        }
    };

    if (loading) return <Skeleton count={10} />;
    if (error) return <div>{error}</div>;
    return (
        <Col lg={12} className="mb-3">
            <Card>
                <Card.Body>
                    <Card.Title>Enrollment</Card.Title>

                    {/* Introductory Row */}
                    {/* <Row className="mb-3">
                        <Col lg={12}>
                            <span>Our records indicate your current data transmission method is</span>
                        </Col>
                    </Row> */}

                    {/* Table Structure */}
                    <div className="table-responsive">
                        <table className="styled-table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th className="vertical-th"></th>
                                    {/* <th><strong>Current Plan Year</strong></th> */}
                                    <th><strong></strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* Toggle Switch Row */}
                                <tr>
                                    <th>If this has changed, please update here</th>
                                    {/* <td>{originalEnrollment?.isChanged ? 'Yes' : 'No'}</td> */}
                                    <td className={enrollment?.isChanged !== originalEnrollment?.isChanged ? '' : ''}>{enrollment?.isChanged ? 'Yes' : 'No'}</td>
                                </tr>

                                {/* Conditional Transmission Type Selection */}
                                {enrollment?.isChanged && (
                                    <>
                                        <tr>
                                            <th>Transmission Type</th>
                                            {/* <td>{originalEnrollment?.transmissionType}</td> */}
                                            <td className={enrollment?.transmissionType !== originalEnrollment?.transmissionType ? 'highlight-difference' : ''}>{enrollment?.transmissionType}</td>
                                        </tr>
                                    </>
                                )}

                                
                                {enrollment?.isChanged && enrollment?.transmissionType === "Vendor" && (
                                    <>
                                        <tr>
                                            <th>Payroll Vendor Name</th>
                                            {/* <td>{originalEnrollment?.vendorName}</td> */}
                                            <td className={enrollment?.vendorName !== originalEnrollment?.vendorName ? 'highlight-difference' : ''}>{enrollment?.vendorName}</td>
                                        </tr>
                                        <tr>
                                            <th>Payroll Vendor Contact First Name</th>
                                            {/* <td>{originalEnrollment?.vendorContactFirstName}</td> */}
                                            <td className={enrollment?.vendorContactFirstName !== originalEnrollment?.vendorContactFirstName ? 'highlight-difference' : ''}>{enrollment?.vendorContactFirstName}</td>
                                        </tr>
                                        <tr>
                                            <th>Payroll Vendor Contact Last Name</th>
                                            {/* <td>{originalEnrollment?.vendorContactLastName}</td> */}
                                            <td className={enrollment?.vendorContactLastName !== originalEnrollment?.vendorContactLastName ? 'highlight-difference' : ''}>{enrollment?.vendorContactLastName}</td>
                                        </tr>
                                        <tr>
                                            <th>Payroll Vendor Contact Email</th>
                                            {/* <td>{originalEnrollment?.vendorContactEmail}</td> */}
                                            <td className={enrollment?.vendorContactEmail !== originalEnrollment?.vendorContactEmail ? 'highlight-difference' : ''}>{enrollment?.vendorContactEmail}</td>
                                        </tr>
                                    </>
                                )}

                                {/* Date Picker Row for Estimated Date of Enrollment Transmission */}
                                <tr>
                                    <th>Estimated Date of Enrollment Transmission</th>
                                    {/* <td>{originalEnrollment?.transmissionDate}</td> */}
                                    <td >{enrollment?.transmissionDate}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
}

export default EbEnrollment
